export default __webpack_public_path__ + "static/media/banner.41e73e02.png";